// extracted by mini-css-extract-plugin
export var dropdownContainer = "_mj-0";
export var leftAlign = "_mj-4";
export var listItem = "_mj-2";
export var listItemWrapper = "_mj-1";
export var operationText = "_mj-3";